const promoErrors = {
  NOT_EXIST: 'Предоставленный код не существует',
  IS_EXPIRED: 'У данного кода истёк срок',
  SOME_ERROR: 'Произошла какая-то ошибка, свяжитесь с поддержкой'
}

export default promoErrors;
